export default "__VITE_ASSET__71c650ea__"